import apiClient from "./api";

export interface DashboardFilters {
  warehouse_id?: string | number;
  from_date?: string;
  to_date?: string;
}

export interface DashboardStatsResponse {
  sales?: number;
  purchases?: number;
  expenses?: number;
  profit?: number;
}

export interface DashboardMonthlyItem {
  month: string;
  sales: number;
  purchases: number;
}

export interface DashboardTopCustomerItem {
  customer_name: string;
  total_amount: number;
}

export interface DashboardTopProductItem {
  product_name: string;
  sold_qty: number;
}

export interface DashboardRecentSaleItem {
  id: number;
  reference_no: string;
  customer_name: string;
  status: string;
  grand_total: number;
  paid: number;
  due: number;
  payment_status: string;
}

export interface DashboardStockAlertItem {
  SKU: string;
  product_name: string;
  warehouse_name?: string;
  quantity: number;
  stock_alert: number;
}

const dashboardService = {
  async getDashboardStats(params?: DashboardFilters): Promise<DashboardStatsResponse> {
    const response = await apiClient.get("/reports/dashboard-stats", { params });
    return response.data;
  },

  async getMonthlySalesPurchases(params?: DashboardFilters): Promise<DashboardMonthlyItem[]> {
    const response = await apiClient.get("/reports/monthly-sales-purchases", { params });
    return response.data || [];
  },

  async getTopCustomers(params?: DashboardFilters): Promise<DashboardTopCustomerItem[]> {
    const response = await apiClient.get("/reports/top-customers", { params });
    return response.data.data || [];
  },

  async getTopSellingProducts(params?: DashboardFilters & { limit?: number }): Promise<DashboardTopProductItem[]> {
    const response = await apiClient.get("/reports/bestSeller", { params });
    return response.data.data || [];
  },

  async getRecentSales(params?: DashboardFilters & { limit?: number }): Promise<DashboardRecentSaleItem[]> {
    const response = await apiClient.get("/reports/recent-sales", { params });
    return response.data.data || [];
  },

  async getStockAlerts(params?: DashboardFilters & { limit?: number }): Promise<DashboardStockAlertItem[]> {
    const response = await apiClient.get("/reports/productsqtyalert", { params });
    return response.data.data || [];
  },
};

export default dashboardService;
